import React from 'react'
import { useTranslation } from 'react-i18next'

import { BaseModalType } from '@context/ModalsContext'

import { Modal } from '@ui/components/Modal'

import { subscriptionTypeOptions } from '@model/SubscriptionTypeOptions'
import { SubscriptionTimeInForce } from '@model/UpdateSubscriptionRequest'

export interface SubscriptionTimeInForceModalProps {
  subscriptionTimeInForceType?: number
  levelDowngrade?: boolean
  context?: unknown
  onConfirm(timeInForceId: SubscriptionTimeInForce, context?: unknown): void
  onCancel?: () => void
}

export const SubscriptionTimeInForceModal: BaseModalType<SubscriptionTimeInForceModalProps> = ({
  subscriptionTimeInForceType,
  levelDowngrade,
  context,
  onConfirm,
  onCancel,
  close,
}) => {
  const { t } = useTranslation()
  const [option, setOption] = React.useState<number | undefined>(subscriptionTimeInForceType)

  React.useEffect(() => {
    setOption(subscriptionTimeInForceType)
  }, [subscriptionTimeInForceType])

  const handleCancel = () => {
    onCancel?.()
    close()
  }

  const handleConfirm = () => {
    if (option === undefined) return
    onConfirm(option as SubscriptionTimeInForce, context)
    close()
  }

  return (
    <Modal>
      <Modal.Header>{t('Market Data.When do you like the subscription to start')}</Modal.Header>
      <Modal.Body>
        <Modal.Body.Input.Radio
          name='subscription-time-in-force'
          value={option !== undefined ? String(option) : ''}
          options={subscriptionTypeOptions.map(({ id, displayName }, idx) => ({
            label: t(displayName),
            value: String(id),
            disabled: idx === 0 && !!levelDowngrade,
          }))}
          onChange={(val: string) => setOption(Number(val))}
        />
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Secondary onClick={handleCancel}>{t('Cancel')}</Modal.Footer.Secondary>
        <Modal.Footer.Primary disabled={option === undefined} onClick={handleConfirm}>
          {t('Confirm')}
        </Modal.Footer.Primary>
      </Modal.Footer>
    </Modal>
  )
}
